import React, { useState } from "react";
import Background from "assets/image/background.jpg";
import cn from "classnames";
import {
  Card,
  CardImg,
  CardText,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import ValidationError from "components/validationError";
import { useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import { selectLanguage } from "store/selector/language";
import { Container } from "reactstrap";
import "assets/styles/components/form.scss";
import { Link } from "react-router-dom";
import {
  REGISTER_VALIDATION_SHEMA,
  REGISTER_INITIAL_VALUE,
} from "fixtureData/formikValidation";

interface FormValues {
  email: string;
  password: string;
}
const Register = () => {
  const { t } = useTranslation();

  const [passwordShow, setPasswordShown] = useState(false);

  const togglePasswordShow = () => {
    setPasswordShown(!passwordShow);
  };

  const formik = useFormik({
    initialValues: REGISTER_INITIAL_VALUE,
    validationSchema: REGISTER_VALIDATION_SHEMA,
    onSubmit: (values) => {
      setTimeout(() => {
        alert(JSON.stringify(values, null, 2));
      }, 400);
    },
  });

  const { errors, touched } = formik;

  return (
    <div
      style={{
        backgroundImage: `url(${Background})`,
      }}
    >
      <Container className=" p-5">
        <Row>
          <Col className="d-flex justify-content-center">
            <Card className={cn("card--dark overflow-hidden")}>
              <Row>
                <Col
                  xs="12"
                  sm="12"
                  lg="5"
                  xl="5"
                  className={cn("p-5 text-light")}
                  style={{
                    backgroundImage: `url(${Background})`,
                  }}
                >
                  <h2 className="text-light">{t("Register")}</h2>

                  <Trans i18nKey="Do you have an account?">
                    <Button outline size="xs" color="danger">
                      {"Login"}
                    </Button>
                  </Trans>
                </Col>
                <Col xs="12" sm="12" lg="7" xl="7">
                  <CardImg width="100%" alt="Logo" className="p-5" />

                  <CardBody>
                    <CardTitle tag="h6" className="pb-5">
                      {t("Register")} <hr />
                    </CardTitle>

                    <CardText>
                      <Form onSubmit={formik.handleSubmit}>
                        <FormGroup className={"form-group-style"}>
                          <Label for="firstName">
                            {t("Name")}
                            <sup>*</sup>
                          </Label>

                          <Input
                            id="firstName"
                            type="text"
                            {...formik.getFieldProps("firstName")}
                          />
                          <ValidationError
                            errors={errors}
                            touched={touched}
                            field="firstName"
                          >
                            {" "}
                            {errors.firstName}{" "}
                          </ValidationError>
                        </FormGroup>

                        <FormGroup className={"form-group-style"}>
                          <Label for="lastName">
                            {t("last name")}
                            <sup>*</sup>
                          </Label>
                          <Input
                            id="lastName"
                            type="text"
                            {...formik.getFieldProps("lastName")}
                          />
                          <ValidationError
                            errors={errors}
                            touched={touched}
                            field="lastName"
                          >
                            {" "}
                            {errors.lastName}{" "}
                          </ValidationError>
                        </FormGroup>
                        <FormGroup className={"form-group-style"}>
                          <Label for="email">
                            {t("Email")}
                            <sup>*</sup>
                          </Label>
                          <Input
                            id="email"
                            type="text"
                            {...formik.getFieldProps("email")}
                          />
                          <ValidationError
                            errors={errors}
                            touched={touched}
                            field="email"
                          >
                            {" "}
                            {errors.email}{" "}
                          </ValidationError>
                        </FormGroup>
                        <FormGroup className={"form-group-style"}>
                          <Label for="password">
                            {t("Password")}
                            <sup>*</sup>
                          </Label>

                          <InputGroup>
                            <Input
                              id="password"
                              {...formik.getFieldProps("password")}
                              type={passwordShow ? "text" : "password"}
                            />

                            <InputGroupAddon addonType="prepend">
                              <InputGroupText onClick={togglePasswordShow}>
                                {passwordShow ? "show" : "hide"}
                              </InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                          <ValidationError
                            errors={errors}
                            touched={touched}
                            field="password"
                          >
                            {" "}
                            {errors.password}{" "}
                          </ValidationError>
                        </FormGroup>
                        <FormGroup className={"form-group-style"}>
                          <Label for="confirmPassword">
                            {t("Repeat password")}
                            <sup>*</sup>
                          </Label>
                          <Input
                            id="confirmPassword"
                            type="text"
                            {...formik.getFieldProps("confirmPassword")}
                          />
                          <ValidationError
                            errors={errors}
                            touched={touched}
                            field="confirmPassword"
                          >
                            {" "}
                            {errors.confirmPassword}{" "}
                          </ValidationError>
                        </FormGroup>

                        <FormGroup className={"form-group-style"}>
                          <Label for="code">
                            {t("Optional consumption code")}
                          </Label>
                          <Input
                            id="code"
                            type="text"
                            {...formik.getFieldProps("code")}
                            onChange={(e) => e}
                          />
                          <ValidationError
                            errors={errors}
                            touched={touched}
                            field="code"
                          >
                            {" "}
                            {errors.code}{" "}
                          </ValidationError>
                        </FormGroup>
                        <FormGroup className="d-flex flex-row align-items-center">
                          <Input type="checkbox" />
                          <Label>
                            <Link to="#">{t("Terms and Conditions")}</Link>{" "}
                            {t("I found out about Queen Nick")}
                          </Label>
                        </FormGroup>
                        <Button type="submit" outline size="xs" color="danger">
                          {t("Confirm and send")}{" "}
                        </Button>
                      </Form>
                    </CardText>
                    <hr />
                    <Row>
                      <Col className="d-flex flex-column align-items-center justify-content-center">
                        <Button size="xs" color="secondary">
                          {t("Login with Google")}
                        </Button>
                        <p>
                          <Trans i18nKey="Signing in with Google means accepting coinnik Market">
                            <Link to="#">{"Terms and Conditions"}</Link>.
                          </Trans>
                        </p>
                      </Col>
                    </Row>
                  </CardBody>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Register;
